import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {EmployeeService} from 'app/blocks/service/api/employee.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {IEmployee} from 'app/blocks/model/employee.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {Employee} from 'app/blocks/model/employee.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class EmployeeResource extends AbstractEntityResource<IEmployee> {
    constructor(employeeService: EmployeeService, router: Router) {
        super(
            Resource.EMPLOYEES,
            employeeService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.EMPLOYEES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.EMPLOYEES),
            (entity?) => new Employee(entity),
            (entity) => entity.employeeId,
            'person'
        );
    }
}
